import BaseApi from '@/api/controller/base';

const API_URL = '3p-docutax/client';

class DocutaxClientApi extends BaseApi {
  constructor() {
    super(API_URL);
  }

  getProfile(clientId) {
    return this.api.get(`${clientId}/profile`);
  }

  update(clientId, data) {
    return this.api.post(`${clientId}`, data);
  }
}

const apiInstance = new DocutaxClientApi();
export { DocutaxClientApi, apiInstance };
export default apiInstance;
